module.exports = __webpack_public_path__ + "img/logo-w.38090a4d.png";